import { render, staticRenderFns } from "./CloseEventBlock.vue?vue&type=template&id=61cf60be&"
import script from "./CloseEventBlock.vue?vue&type=script&lang=js&"
export * from "./CloseEventBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports